import React from 'react'
import Collapsible from 'react-collapsible'
import styled from 'styled-components'

const AccordionMobileNavbar = (props) => {
  return (
    <AccordionWrapper>
      <Collapsible
        containerElementProps={{ id: `container-element-${props.id}-id-navbar` }}
        contentElementId={`content-element-${props.id}-id-navbar`}
        triggerElementProps={{ id: `trigger-element-${props.id}-id-navbar` }}
        transitionTime={175}
        trigger={
          <Trigger>
            <span>{props.head}</span>
          </Trigger>
        }
      >
        <AccordionText>{props.text}</AccordionText>
      </Collapsible>
    </AccordionWrapper>
  )
}

export default AccordionMobileNavbar

const AccordionWrapper = styled.div`
  width: 100%;

  img {
    width: 12px;
    opacity: 0.5;
  }
  .is-open {
    img {
      transform: rotate(180deg);
      opacity: 1;
    }
  }
`

const Trigger = styled.span`
  display: flex;
  justify-content: center;
`

const AccordionText = styled.div``
